/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Freefeature21Inputs */

const zh_plan_freefeature21 = /** @type {(inputs: Plan_Freefeature21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 个学习空间`)
};

const en_plan_freefeature21 = /** @type {(inputs: Plan_Freefeature21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 learning spaces`)
};

const es_plan_freefeature21 = /** @type {(inputs: Plan_Freefeature21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 espacios de aprendizaje`)
};

/**
* | output |
* | --- |
* | "5 learning spaces" |
*
* @param {Plan_Freefeature21Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_freefeature21 = /** @type {((inputs?: Plan_Freefeature21Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Freefeature21Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_freefeature21(inputs)
	if (locale === "en") return en_plan_freefeature21(inputs)
	return es_plan_freefeature21(inputs)
});
export { plan_freefeature21 as "plan_freeFeature2" }